// extracted by mini-css-extract-plugin
export default {"container":"EditBlog_container__DdikL","btn":"EditBlog_btn__7TwtS","cancel":"EditBlog_cancel__N9l-Z","align-right":"EditBlog_align-right__sxDlv"};